export default __webpack_public_path__ + "static/media/screenshot.75829263.jpg";